<template>

  <!-- Being Scheduled (BEING_SCHEDULED) -->
  <order-list-data-table
      title="Being Scheduled"
      defaultSortField="scheduled_delivery"
      defaultSortOrder="dsc"
      routeClickGoTo="route-builder"
      :headers="headers"
      :status="status"
      :assocs="assocs"
      :notifications="notifications"
      :linkToLocations="true" />

</template>

<script>
import OrderListDataTable from '@/components/orders/OrderListDataTable'

export default {
  name: 'OrderListBeingScheduledPage',

  components: {
    OrderListDataTable
  },

  data () {
    return {
      headers: [
        { text: 'Notifications', value: 'notifications', sortable: false, width: '48px' },
        { text: 'Order#', value: 'order_number' },
        // { text: 'Provider', value: 'provider_alias' },
        // { text: 'Account', value: 'thirdparty_account_name' },
        { text: 'Brand', width: '140px', value: 'thirdparty_brand_name' },
        { text: 'Route', value: 'route_id' },
        { text: 'From', value: 'shipper.name' },
        { text: 'To', value: 'receiver.name' },
        { text: 'Expected Delivery', value: 'expected_delivery', align: 'center' },
        { text: 'Scheduled Delivery', value: 'scheduled_delivery', align: 'center' },
        { text: 'Est. Pickup', value: 'estimated_shipper_arrival_time' },
        { text: 'Est. at Receiver', value: 'estimated_receiver_arrival_time' },
        { text: 'Status', value: 'order_status' }
      ],
      status: ['BEING_SCHEDULED'],
      assocs: 'shipper,receiver,order_details,parent_order,route'
    }
  },

  computed: {
    notifications () {
      return this.$parent.notifications
    }
  }
}
</script>

<style scoped>
</style>
